module.exports = __webpack_public_path__ + "img/listening-feedback.50641679.svg";